import { Expose } from 'class-transformer';

export class GenreApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  description: string;
}
